__turbopack_context__.v({
  "icon": "_4omcya_icon",
});
